import { ShopPage } from '@/features/shop/ShopPage';

export function Component() {
  return <ShopPage />;
}
